export default "__VITE_ASSET__CcEd5LsL__"